import React from 'react';
import { Lock } from 'lucide-react';
import { mensagemDoErro } from '../utils/erros';

/**
 * Estado da tela quando o perfil não tem a permissão necessária.
 *
 * Ocupa o lugar da lista, em vez de aparecer como erro passageiro: a pessoa
 * precisa entender que não é uma falha e que recarregar não vai adiantar.
 */
const AvisoSemPermissao: React.FC<{ erro: any; alternativa?: string }> = ({
  erro, alternativa = 'Você não tem permissão para ver este conteúdo.',
}) => (
  <div className="bg-white rounded-lg border border-amber-200 p-10 text-center">
    <div className="w-12 h-12 rounded-full bg-amber-50 flex items-center justify-center mx-auto mb-4">
      <Lock className="h-6 w-6 text-amber-600" />
    </div>
    <h2 className="text-lg font-semibold text-gray-900 mb-1">Acesso não liberado</h2>
    <p className="text-gray-600 max-w-md mx-auto">{mensagemDoErro(erro, alternativa)}</p>
    <p className="text-sm text-gray-500 mt-3">
      Se você precisa deste acesso, peça ao administrador da empresa para liberá-lo
      em Permissões.
    </p>
  </div>
);

export default AvisoSemPermissao;
